import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { createComponent } from 'react-fela'

import { __slider, __handle } from './__style'

const Slider = createComponent(__slider)
const Handle = createComponent(__handle)

/**
 * A radio button that can be switched on and off
 */
export default class RadioButton extends Component {
	static propTypes = {
		/** Fill color when radio button is on. */
		fillColor: PropTypes.string,
		/** Fill color name when radio button is off. */
		offColor: PropTypes.string,
		/** Width of the radio button. (Height is set to 0.4 * size). */
		size: PropTypes.number,
		/** Toggle this to switch the radio button on and off. */
		isOn: PropTypes.bool,
		/** Toggle this to enable and disable the radio button. */
		isEnabled: PropTypes.bool,
		/** Enable the radio button but not toggleable */
		isReadOnly: PropTypes.bool,
		/** Callback to call when radio button is toggled. */
		onToggle: PropTypes.func,
	}

	static defaultProps = {
		size: 32,
		isOn: false,
		isEnabled: true,
		isReadOnly: false,
	}

	constructor(props) {
		super(props)
		this.state = {
			isOn: props.isOn,
		}
	}

	toggleButton = () => {
		if (!this.props.readOnly) {
			this.setState(
				({ isOn }) => ({
					isOn: !isOn,
				}),
				() => {
					this.props.onToggle(this.state.isOn)
				}
			)
		}
	}

	// eslint-disable-next-line camelcase
	UNSAFE_componentWillReceiveProps(nextProps) {
		const { isOn } = this.props
		if (isOn !== nextProps.isOn) this.setState({ isOn: nextProps.isOn })
	}

	renderInputElement() {
		const { isEnabled, isReadOnly } = this.props
		const { isOn } = this.state

		if (!isEnabled || isReadOnly)
			return (
				<input
					type="checkbox"
					disabled={!isEnabled}
					checked={isEnabled && isOn}
					readOnly={isEnabled && isReadOnly}
					value={isEnabled ? isOn : ''}
				/>
			)

		return (
			<input
				type="checkbox"
				value={isOn}
				checked={isOn}
				onChange={this.toggleButton}
			/>
		)
	}

	render() {
		const { isEnabled, size, fillColor, offColor } = this.props
		const { isOn } = this.state

		return (
			<div>
				<Slider
					isOn={isOn}
					isEnabled={isEnabled}
					size={size}
					fillColor={fillColor}
					offColor={offColor}
				>
					{this.renderInputElement()}
					<Handle
						isOn={isOn}
						isEnabled={isEnabled}
						size={size}
						fillColor={fillColor}
						offColor={offColor}
					/>
				</Slider>
			</div>
		)
	}
}
